import React from 'react';
import { IoArrowBack } from 'react-icons/io5';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from './firebase';

export default function Support() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    const from = location.state?.from;
    if (from && from !== '/support') {
      navigate(from);
    } else {
      navigate('/');
    }
  };

  return (
    <div style={styles.container}>
      <button onClick={handleBack} style={styles.backButton}>
        <IoArrowBack size={24} />
      </button>

      <h1 style={styles.title}>Wishare – Support</h1>
      <p style={styles.text}>If you need help or want to report a problem, you can contact us at:</p>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>Email</h2>
        <p style={styles.text}>
          <a href="mailto:support@wishareapp.com" style={styles.link}>support@wishareapp.com</a>
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>Instagram</h2>
        <p style={styles.text}>
          <a href="https://instagram.com/wishareapp" target="_blank" rel="noopener noreferrer" style={styles.link}>
            instagram.com/wishareapp
          </a>
        </p>
      </div>

      <hr style={styles.divider} />

      <footer style={styles.footer}>
        © 2025 Wishare. All rights reserved.
      </footer>
    </div>
  );
}

const styles = {
  container: {
    fontFamily: 'Poppins, sans-serif',
    maxWidth: '600px',
    margin: '0 auto',
    padding: '20px',
    minHeight: '100vh',
    color: '#111',
  },
  backButton: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    marginBottom: '20px',
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    marginBottom: '20px',
    marginTop: '20px',
  },
  subtitle: {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '12px',
    marginTop: '24px',
  },
  section: {
    marginBottom: '24px',
  },
  text: {
    fontSize: '15px',
    lineHeight: '1.6',
    color: '#333',
    marginBottom: '12px',
  },
  link: {
    color: '#007aff',
    textDecoration: 'none',
  },
  divider: {
    margin: '32px 0',
    border: 'none',
    borderTop: '1px solid #eee',
  },
  footer: {
    fontSize: '13px',
    color: '#666',
    textAlign: 'center',
    marginTop: '32px',
  },
};
